import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

import { Store, createSelector } from '@ngrx/store';

import { FreyaCommonModule } from '../../../freya-common/freya-common.module';


import { SharedModule } from '../../../shared/shared.module';

import { quickAccessFeature, selectPinnedJobs, selectRecentJobs } from './quick-access-reducers';
import { QuickAccessActions } from './quick-access.actions';

@Component({
  selector: 'app-quick-access',
  standalone: true,
  imports: [
    FreyaCommonModule,
    CommonModule,
    SharedModule,
  ],
  templateUrl: './quick-access.component.html',
  styleUrl: './quick-access.component.scss'
})
export class QuickAccessComponent {

  public QuickAccessActions = QuickAccessActions;

  public viewModel$ = this.store.select(createSelector({
    pinnedJobs: selectPinnedJobs,
    recentJobs: selectRecentJobs,
    expanded: quickAccessFeature.selectExpanded,
    isEmpty: createSelector(
      selectPinnedJobs,
      selectRecentJobs,
      (pinned, recent) => {
        const total = pinned.length + recent.length;
        return total === 0;
      }
    ),
  }));

  constructor(
    public store: Store,
  ) {}
}
